<div class="impressum-backdrop">
  <article class="impressum-dialog" role="dialog" aria-modal="true" aria-labelledby="impressum-title">
    <header class="impressum-header">
      <div>
        <p class="impressum-eyebrow">Creditreform Schuldnerportal</p>
        <h2 id="impressum-title">IMPRESSUM</h2>
      </div>
      <button class="impressum-close" type="button" (click)="onClose()" aria-label="Impressum schließen">&times;</button>
    </header>

    <div class="impressum-body">
      @if (location; as location) {
      <section class="impressum-location" aria-labelledby="impressum-company-title">
        <p>Dieses Internetangebot wird Ihnen zur Verfügung gestellt von:</p>
        <h4>Angaben gemäß § 5 DDG:</h4>
        <address>
          <strong>{{ location.company }}</strong><br>
          @for (line of location.addressLines; track line) {
            {{ line }}<br>
          }
          @for (phone of location.phones; track phone) {
            Tel: {{ phone }}<br>
          }
          @for (fax of location.faxes; track fax) {
            Fax: {{ fax }}<br>
          }
          @if (location.email) {
            <a [href]="'mailto:' + location.email">{{ location.email }}</a><br>
          }
          @if (location.website) {
            <a [href]="location.website" target="_blank" rel="noopener">{{ websiteLabel(location.website) }}</a>
          }
        </address>
        <h4>Vertretungsberechtigt/e</h4>
        <p>
          @for (representative of location.representatives; track representative; let last = $last) {
            {{ representative }}@if (!last) { <br> }
          }
        </p>
        <p>{{ location.register }}</p>
        <p>{{ location.vatId }}</p>
        <p>Registriertes Inkassounternehmen im Rechtsdienstleistungsregister. Aufsichtsbehörde i.S.d. § 5 Abs.1 Nr.3 DDG: Bundesamt für Justiz, Adenauerallee 99-103, 53113 Bonn, E-Mail: <a href="mailto:rdg@bfj.bund.de">rdg@bfj.bund.de</a></p>
        <h4>Journalistisch-redaktioneller Inhalt nach § 18 Abs. 2 MStV</h4>
        <p>Verantwortlich für Beiträge mit journalistisch-redaktionellem Inhalt nach § 18 Abs. 2 MStV ist Herr Stefano Kleinen, Anschrift siehe oben.</p>
        <p>Hinweis nach § 36 Verbraucherstreitbeilegungsgesetz (VSBG): Die {{ location.vsbgCompany }} nimmt nicht an einem Streitbeilegungsverfahren im Sinne des Verbraucherstreitbeilegungsgesetzes teil. Es besteht diesbezüglich keine gesetzliche Verpflichtung.</p>
        <p>Haftung für Links: Unsere Internetseiten enthalten Links auf externe Webseiten. Diese Links haben einen reinen Informationszweck. Auf die Entwicklung der Inhalte dieser verlinkten Webseiten haben wir keinen Einfluss. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich. Des Weiteren distanziert sich die {{ location.vsbgCompany }} ausdrücklich von allen Inhalten, die straf- oder haftungsrechtlich relevant sind oder gegen die guten Sitten verstoßen.</p>
      </section>
      }
    </div>
  </article>
</div>
